// /app/frontend/src/components/handshake/StoreFixedQR.js
// QR Code fixo da loja para entregadores escanearem
import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { FiDownload, FiPrinter, FiRefreshCw, FiShield } from 'react-icons/fi';
import api from '@/services/api';

const StoreFixedQR = () => {
  const [storeQR, setStoreQR] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadStoreQR();
  }, []);

  const loadStoreQR = async () => {
    try {
      const response = await api.get('/stores/my/qr-token');
      setStoreQR(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao carregar QR Code');
    } finally {
      setLoading(false);
    }
  };

  const downloadQR = () => {
    const svg = document.getElementById('store-fixed-qr');
    if (!svg) return;
    
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = 400;
      canvas.height = 500;
      
      // Fundo branco
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // QR Code
      ctx.drawImage(img, 50, 50, 300, 300);
      
      // Texto
      ctx.fillStyle = '#333';
      ctx.font = 'bold 24px Arial';
      ctx.textAlign = 'center';
      ctx.fillText(storeQR.store_name, 200, 400);
      
      ctx.font = '14px Arial';
      ctx.fillStyle = '#666';
      ctx.fillText('Escaneie para confirmar coleta', 200, 430);
      ctx.fillText('BARUERIFLASH', 200, 460);
      
      const link = document.createElement('a');
      link.download = `qrcode_loja_${storeQR.store_name.replace(/\s+/g, '_')}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    };
    
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
  };

  const printQR = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>QR Code - ${storeQR?.store_name}</title>
        <style>
          body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            margin: 0;
            font-family: Arial, sans-serif;
          }
          .qr-container {
            text-align: center;
            padding: 20px;
            border: 2px dashed #ccc;
            border-radius: 16px;
          }
          h1 { font-size: 24px; color: #333; margin-bottom: 10px; }
          p { color: #666; margin: 5px 0; }
          .brand { color: #DC143C; font-weight: bold; margin-top: 20px; }
          @media print {
            .qr-container { border: none; }
          }
        </style>
      </head>
      <body>
        <div class="qr-container">
          ${document.getElementById('store-fixed-qr')?.outerHTML}
          <h1>${storeQR?.store_name}</h1>
          <p>Escaneie para confirmar coleta</p>
          <p class="brand">BARUERIFLASH</p>
        </div>
        <script>
          window.onload = function() { window.print(); window.close(); }
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-red-500 border-t-transparent"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 bg-red-50 border border-red-200 rounded-xl">
        <p className="text-red-700">{error}</p>
        <button onClick={loadStoreQR} className="mt-2 text-sm text-red-600 hover:text-red-800">
          Tentar novamente
        </button>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border p-6" data-testid="store-fixed-qr">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-gray-800 flex items-center gap-2">
          <FiShield className="text-green-500" />
          QR Code da Loja (Fixo)
        </h3>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-4">
        <p className="text-sm text-green-700">
          Este QR Code é <strong>permanente</strong>. Imprima e deixe visível no balcão da loja 
          para que os entregadores possam escanear ao coletar pedidos.
        </p>
      </div>

      <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl p-6 text-center mb-4">
        <QRCodeSVG
          id="store-fixed-qr"
          value={storeQR.store_qr_token}
          size={200}
          level="H"
          includeMargin
          className="mx-auto"
        />
        <p className="mt-4 font-bold text-gray-800">{storeQR.store_name}</p>
        <p className="text-sm text-gray-500">Escaneie para confirmar coleta</p>
      </div>

      <div className="flex gap-3">
        <button
          onClick={downloadQR}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700"
        >
          <FiDownload />
          Baixar PNG
        </button>
        <button
          onClick={printQR}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-gray-600 text-white rounded-xl hover:bg-gray-700"
        >
          <FiPrinter />
          Imprimir
        </button>
      </div>

      <p className="text-xs text-gray-400 text-center mt-4">
        Código: {storeQR.store_qr_token}
      </p>
    </div>
  );
};

export default StoreFixedQR;
